import script from "./PreRegisterDevicesDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreRegisterDevicesDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PreRegisterDevicesDialog.vue?vue&type=style&index=0&id=011c3998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-011c3998"]])

export default __exports__